import React, {useCallback} from 'react';
import {DialogTypes} from 'common/names';
import {SetValueOptions} from 'components/hook-form/helpers';
import {useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {IAuthenticationPolicies} from 'types/AuthenticationPolicies';
import {IIPAccessRulesSettings} from 'types/diplomat/sftp/IPAccessRulesSettings';
import Button from 'components/Button';
import {readOnlyContext} from 'common/context/ReadOnlyContext';
import {useOpenSubDialogCb} from 'features/layout/redux/hooks/useOpenSubDialogCb';

export const IPAccessRuleButton = ({text, isAdmin}: {text?: string; isAdmin?: boolean}) => {
   const {t} = useTranslation();
   const {setValue, watch} = useFormContext<IAuthenticationPolicies>();
   const readOnly = React.useContext(readOnlyContext);

   const onClose = useCallback(
      (values?: IIPAccessRulesSettings) => {
         if (values) {
            console.debug('close', values);
            setValue('accessRule', values, SetValueOptions);
         }
      },
      [setValue]
   );

   const openIPAccessRulesDialog = useOpenSubDialogCb();

   const openDialog = useCallback(() => {
      openIPAccessRulesDialog(
         DialogTypes.IPAccessRules.id,
         {
            values: watch('accessRule'),
            text,
            submitLabel: 'Ok',
            isAdmin,
         },
         undefined,
         undefined,
         onClose
      );
   }, [watch, openIPAccessRulesDialog, onClose]);

   return (
      <Button onClick={openDialog} disabled={readOnly}>
         {t('IP Access Rules')}
      </Button>
   );
};
